import React, { useState } from "react";
import styles from "./OTP.module.css";
import { useForm, Controller } from "react-hook-form";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import validator from "validator";
import useGeoLocation from "@/services/useGeoLocation";
import { Info } from "lucide-react";

interface UpdatePhoneProps {
  setStep: (step: number) => void;
  setMobileNumber: (number: string) => void;
  mobileNumber: string;
  handleCountryCodeChange: (country: any) => void;
  handlesendOTP: () => void;
}

interface FormData {
  phone: string;
}
const UpdatePhone = ({
  setStep,
  setMobileNumber,
  mobileNumber,
  handleCountryCodeChange,
  handlesendOTP,
}: UpdatePhoneProps) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormData>();

  const [phoneNumberError, setPhoneNumberError] = useState<string>("");
  const [isValidPhoneNumberData, setIsValidPhoneNumberData] = useState(false);
  const geoLocationData: any = useGeoLocation();
  const [isFocused, setIsFocused] = useState(false);

  const onSubmit = (data: FormData) => {
    if (!mobileNumber || !isValidPhoneNumber(mobileNumber)) {
      setIsValidPhoneNumberData(false);
      alert("Please enter a valid phone number.");
      return;
    }
    setIsValidPhoneNumberData(true);
    setMobileNumber(data.phone);
    setStep(2);
  };

  return (
    <div className={styles.otpCompoContainer}>
      <div>
        <h1 className={styles.otpHeader}>Update Phone Number</h1>
        <p className={styles.otpSubText}>
          Please enter your new mobile number below to update.
        </p>
      </div>
      <form
        action=""
        className={styles.updatePhoneForm}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className={styles.fieldInPut}>
          <Controller
            name="phone"
            control={control}
            rules={{
              required: "Phone number is required",
            }}
            render={({ field }) => (
              <PhoneInput
                {...field}
                value={mobileNumber}
                international
                countryCallingCodeEditable={false}
                onFocus={() => setIsFocused(true)}
                onChange={(value) => {
                  const phoneNumber = value ? value.toString() : "";
                  const isValid = validator.isMobilePhone(phoneNumber || "");
                  setMobileNumber(phoneNumber as string);
                  field.onChange(phoneNumber);

                  if (phoneNumber.replace(/[^0-9]/g, "").length >= 4) {
                    if (isValid) {
                      setMobileNumber(phoneNumber);
                      setPhoneNumberError("");
                    } else {
                      setPhoneNumberError("Valid phone number required");
                    }
                  } else {
                    setPhoneNumberError("");
                  }
                }}
                onCountryChange={handleCountryCodeChange}
                defaultCountry={geoLocationData?.countryCode}
              />
            )}
          />
        </div>
        <div className={styles.noticeText}>
          {isFocused && (
            <small className={styles.info}>
              <Info />
              <span className="ms-1">
                OTP will be sent to your registered mobile number.
              </span>
            </small>
          )}
        </div>
        {phoneNumberError ? (
          <small className={styles.error}>{phoneNumberError}</small>
        ) : (
          (mobileNumber?.length === 0
            ? !phoneNumberError
            : phoneNumberError || isValidPhoneNumberData) &&
          errors?.phone && (
            <small className={styles.error}>{errors?.phone?.message}</small>
          )
        )}
        <div className="d-flex align-items-center justify-content-center mt-5">
          <button className={styles.sentOtpButton} onClick={handlesendOTP}>
            Send OTP
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdatePhone;
